export default __webpack_public_path__ + "static/media/EM0770.34I-21941_-14978_0.a9443d2c.jpg";